import API from "@/lib/API";

export const siteVisitService = {
  getSiteVisits: async (params = {}) => {
    return await API.get('/verve-leads', { params });
  },

  submitSiteVisit: async (id, data) => {
    const formData = new FormData();
    
    // Append JSON data as string
    const { siteVisitFiles, ...jsonData } = data;
    formData.append('siteVisitData', JSON.stringify(jsonData));
    
    // Append files
    if (siteVisitFiles && Array.isArray(siteVisitFiles)) {
      siteVisitFiles.forEach(fileObj => {
        // fileObj should be { file: File, uploadId: string }
        if (fileObj.file instanceof File) {
          // Send the uploadId as the filename so the backend can extract it
          formData.append('siteVisitFiles', fileObj.file, `${fileObj.uploadId}___${fileObj.file.name}`);
        }
      });
    }
    
    return await API.post(`/verve-leads/${id}/site-visit`, formData);
  },

  deleteSiteVisit: async (id) => {
    return await API.delete(`/verve-leads/${id}/site-visit`);
  },

  updateLead: async (id, data) => {
    return await API.patch(`/verve-leads/${id}`, data);
  }
};
